jQuery( document ).ready(function() {
    jQuery('.hamburger').on('click',function() {
        if (jQuery('.hamburger').hasClass('is-active')) {
            jQuery('.hamburger').removeClass('is-active');
            jQuery('body').removeClass('mobile-menu-active');
        } else {
            jQuery('.hamburger').addClass('is-active');
            jQuery('body').addClass('mobile-menu-active');
        }
        
      });
    
    jQuery('#closeMobileMenu').on('click', function() {
        jQuery('body').removeClass('mobile-menu-active');
    });

      jQuery(document).ready(function(){
        jQuery('.HeaderSlideshow').bxSlider({
            mode: 'fade',
            auto: true,
            pager: false
        });
      });
});

jQuery.fn.visible = function(partial) {

  var $t = jQuery(this),
    $w = jQuery(window),
    viewTop = $w.scrollTop(),
    viewBottom = viewTop + $w.height(),
    _top = $t.offset().top,
    _bottom = _top + $t.height(),
    compareTop = partial === true ? _bottom : _top,
    compareBottom = partial === true ? _top : _bottom;

  return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
}

jQuery(document).ready(function(e) {
  checkVisible();
});

jQuery(window).scroll(function(e) {
  checkVisible();
});


function checkVisible() {
  jQuery('.section').each(function(i, k) {
    if (jQuery(this).visible()) {
      jQuery(k).addClass('section-active');
    } /*else {
      jQuery(k).removeClass('section-active');
    }*/
  });
}

